import script from "./otpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./otpModal.vue?vue&type=script&setup=true&lang=js"

import "./otpModal.vue?vue&type=style&index=0&id=7099372d&lang=css"

const __exports__ = script;

export default __exports__